import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { submit } from "redux-form";
import { bindActionCreators } from "redux";
import { pushMessage, removeMessage } from "../../redux/actions/commonActions";
import {
  getQuestionsToReview,
  getSubjectAreas,
  acceptQuestion,
  rejectQuestion,
  deleteQuestion,
  rejectDeletionSuggestion,
  getFaqCmsSettings
} from "../../redux/actions/faqCmsActions";
import { generatePublicChatbotSnippet } from "../../redux/actions/connectionActions";
import { fetchSkill } from "../../redux/actions/skillActions";
import {
	Paper,
	withStyles,
	Box,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
} from "@material-ui/core";
import { Dashboard as DashboardLayout } from "../../layouts";
import MaterialTable from "material-table";
import styles from "./styles";
import MaterialTableIcons from "./materialTableIcons";
import { FAQ_CMS_REDUX_QUESTION_FORM_NAME } from "../../constants";
import Edit from "@material-ui/icons/Edit";
import QuestionForm from "./components/QuestionForm";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { formatDate } from "../../common/utils";
import { extendFormDataWithSelectValues } from "./faqCmsUtils";

const ACCEPT_QUESTION_REVIEW_ACTION = "ACCEPT_QUESTION_REVIEW_ACTION";
const REJECT_QUESTION_REVIEW_ACTION = "REJECT_QUESTION_REVIEW_ACTION";
const DELETE_QUESTION_REVIEW_ACTION = "DELETE_QUESTION_REVIEW_ACTION";
const REJECT_DELETION_SUGGESTION_REVIEW_ACTION = "REJECT_DELETION_SUGGESTION_REVIEW_ACTION";

// Todo change class name to be more precise?
class FaqCms extends Component {
	constructor(props) {
		super(props);
		this.initialComponentState = {
			isLoading: true,
			showQuestionForm: false,
			questionFormIsDisabled: false,
			currentQuestion: { data: {}, tableIdx: undefined },
			lastReviewActionClicked: undefined,
		};
		this.state = { ...this.initialComponentState };
		this.customFields = undefined;
		this.faqsTableColumns = [
			{ title: "Question", field: "question" },
			{ title: "Subject Area", field: "subjectArea" },
			{ title: "User", field: "user" },
			{
				title: "Date Submitted",
				field: "dateSubmitted",
				type: "date",
				defaultSort: "desc",
				render: rowData => formatDate(rowData["dateSubmitted"]),
			},
			{
				title: "Status",
				field: "status",
			},
		];
		this.subjectAreaKey = "subjectArea";
	}

	async componentDidMount() {
		const {
			skill,
			fetchSkill,
			generatePublicChatbotSnippet,
			publicChatbotProps,
			getQuestionsToReview,
			getSubjectAreas,
			getFaqCmsSettings,
		} = this.props;

		if (!skill || _.isEmpty(skill)) {
			await fetchSkill();
		}

		if (!publicChatbotProps) {
			await generatePublicChatbotSnippet();
		}

		await Promise.all([getSubjectAreas(), getFaqCmsSettings()]);
		const customFields = _.get(this.props.faqCmsSettings, "customFields", null);
		this.customFields =
			customFields && customFields.length ? customFields : null;
		await getQuestionsToReview(this.customFields);

		this.setState({ isLoading: false });
	}

	getCustomFieldsInputNames = () => {
		if (!this.customFields) {
			return [];
		}

		return this.customFields.map(customField => customField.name);
	};

	handleReviewQuestionClick = (event, rowData) => {
		const tableIdx = rowData.tableData.id;
		const customFieldsNames = this.getCustomFieldsInputNames();
		const currentQuestionData = _.pick(this.props.questionsToReview[tableIdx], [
			"question",
			"subjectArea",
			"htmlResponse",
			"voiceResponse",
			"docId",
			"status",
			...customFieldsNames,
		]);
		const stateUpdate = {
			currentQuestion: { data: currentQuestionData, tableIdx: tableIdx },
		};

		if (!this.state.showQuestionForm) {
			stateUpdate.showQuestionForm = true;
		}

		this.setState(stateUpdate);
	};

	resetFormAndReloadTableData = async () => {
		this.setState(this.initialComponentState);
		await this.props.getQuestionsToReview(this.customFields);
		this.setState({ isLoading: false });
	};

	handleQuestionFormSubmit = async (
		reviewQuestion,
		reviewDecision,
		questionData,
		successMsg,
	) => {
		this.setState({ questionFormIsDisabled: true });
		await reviewQuestion(questionData);
		this.setState({ showQuestionForm: false, questionFormIsDisabled: false });

		if (this.props.reviewApiCallResponse === 200) {
			this.props.pushMessage({ type: "success", message: successMsg });
			await this.resetFormAndReloadTableData();
			return;
		}

		this.props.pushMessage({
			type: "error",
			message: "An error occurred while reviewing the question",
		});
	};

	handleReviewButtonClick = reviewType =>
		this.setState({ lastReviewActionClicked: reviewType }, () =>
			// More info on "remotely" submitting redux-form forms: https://redux-form.com/8.2.2/examples/remotesubmit/
			this.props.dispatch(submit(FAQ_CMS_REDUX_QUESTION_FORM_NAME)),
		);

	getReviewButtons = questionData => {
		const { classes } = this.props;
		const commonProps = {
			variant: "contained",
			disabled: this.state.questionFormIsDisabled,
		};

		const currentQuestionStatus = _.get(questionData, "status", undefined);
		let buttons;

		// Todo extract const
		if (currentQuestionStatus === "TO BE DELETED") {
			buttons = (
				<React.Fragment>
					<Button
						color="primary"
						{...commonProps}
						onClick={() =>
							this.handleReviewButtonClick(
								REJECT_DELETION_SUGGESTION_REVIEW_ACTION,
							)
						}
					>
						Keep Question
					</Button>
					<Button
						{...commonProps}
						className={classes.deleteQuestionButton}
						onClick={() =>
							this.handleReviewButtonClick(DELETE_QUESTION_REVIEW_ACTION)
						}
					>
						Delete
					</Button>
				</React.Fragment>
			);
		} else {
			buttons = (
				<React.Fragment>
					<Button
						color="secondary"
						{...commonProps}
						onClick={() =>
							this.handleReviewButtonClick(REJECT_QUESTION_REVIEW_ACTION)
						}
					>
						Reject
					</Button>
					<Button
						color="primary"
						{...commonProps}
						onClick={() =>
							this.handleReviewButtonClick(ACCEPT_QUESTION_REVIEW_ACTION)
						}
					>
						Accept
					</Button>
				</React.Fragment>
			);
		}

		return <div className={classes.reviewButtonsContainer}>{buttons}</div>;
	};

	getCustomFieldValueLabel = (customFieldInputName, customFieldValue) => {
		const customField = this.customFields.find(
			customField => customField.name === customFieldInputName,
		);

		if (!customField) {
			return undefined;
		}

		const option = customField.options.find(
			option => option.value === customFieldValue,
		);

		if (!option) {
			return undefined;
		}

		return option.label;
	};

	/**
	 * Handle values for react-select.
	 */
	prepareFormData = data => {
		const newFormData = _.omit(data, "status");

		if (data.hasOwnProperty(this.subjectAreaKey)) {
			const subjectArea = data[this.subjectAreaKey];
			newFormData[this.subjectAreaKey] = {
				value: subjectArea,
				label: subjectArea,
			};
		}

		if (!this.customFields) {
			return newFormData;
		}

		// Convert strings to objects for react-select
		for (const customField of this.customFields) {
			const customFieldName = customField.name;
			if (data.hasOwnProperty(customFieldName)) {
				const value = data[customFieldName];
				const label = this.getCustomFieldValueLabel(customFieldName, value);

				if (value && label) {
					newFormData[customFieldName] = { value: value, label: label };
				}
			} else {
				const firstOption = customField.options[0];
				newFormData[customFieldName] = {
					value: firstOption.value,
					label: firstOption.label,
				}; // Set default value
			}
		}

		return newFormData;
	};

	getReviewFunction = () => {
		const {
			acceptQuestion,
			rejectQuestion,
			deleteQuestion,
			rejectDeletionSuggestion,
		} = this.props;
		const { lastReviewActionClicked } = this.state;

		switch (lastReviewActionClicked) {
			case REJECT_QUESTION_REVIEW_ACTION:
				return {
					reviewFunction: rejectQuestion,
					successMsg: "Question rejected successfully",
				};
			case ACCEPT_QUESTION_REVIEW_ACTION:
				return {
					reviewFunction: acceptQuestion,
					successMsg: "Question accepted successfully",
				};
			case REJECT_DELETION_SUGGESTION_REVIEW_ACTION:
				return {
					reviewFunction: rejectDeletionSuggestion,
					successMsg: "Deletion suggestion rejected successfully",
				};
			case DELETE_QUESTION_REVIEW_ACTION:
				return {
					reviewFunction: deleteQuestion,
					successMsg: "Question deleted successfully",
				};
			default:
				return () => {};
		}
	};

	renderReviewQuestionForm = () => {
		if (!this.state.showQuestionForm) {
			return null;
		}

		const { classes, existingSubjectAreas } = this.props;
		const {
			questionFormIsDisabled,
			currentQuestion,
			lastReviewActionClicked,
		} = this.state;
		const { reviewFunction, successMsg } = this.getReviewFunction();

		return (
			<Grid container justify="center">
				<Paper elevation={1} className={classes.questionFormContainer}>
					<QuestionForm
						customFields={this.customFields}
						formDisabled={questionFormIsDisabled}
						formData={this.prepareFormData(currentQuestion.data)}
						buttons={this.getReviewButtons(currentQuestion.data)}
						onSubmit={e => {
							const questionDataWithId = {
								...e,
								docId: currentQuestion.data.docId,
							};
							const newQuestionData = extendFormDataWithSelectValues(
								questionDataWithId,
								this.customFields,
							);
							this.handleQuestionFormSubmit(
								reviewFunction,
								lastReviewActionClicked,
								newQuestionData,
								successMsg,
							);
						}}
						subjectAreas={existingSubjectAreas}
					/>
				</Paper>
			</Grid>
		);
	};

	renderTableWithQuestions = () => {
		return (
			<MaterialTable
				title="Questions waiting to be reviewed"
				icons={MaterialTableIcons}
				columns={this.faqsTableColumns}
				data={this.props.questionsToReview}
				actions={[
					{
						icon: () => <Edit />,
						tooltip: "Review Question",
						onClick: this.handleReviewQuestionClick,
					},
				]}
				options={{
					sorting: true,
				}}
			/>
		);
	};

	render() {
		return (
			<DashboardLayout title="FAQ CMS" isLoading={this.state.isLoading}>
				{this.renderReviewQuestionForm()}
				<div className={this.props.classes.tableWithQuestionsContainer}>
					{this.renderTableWithQuestions()}
				</div>
			</DashboardLayout>
		);
	}
}

function mapStateToProps(state) {
  const { questionsToReview, existingSubjectAreas, reviewApiCallResponse, reviewedQuestion, settings } = state.faqCms;
  const { publicChatbotProps } = state.connections;
  const { skill } = state;

  return {
    skill,
    publicChatbotProps,
    questionsToReview,
    existingSubjectAreas,
    reviewApiCallResponse,
    reviewedQuestion,
    faqCmsSettings: settings
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        pushMessage,
        removeMessage,
        fetchSkill,
        generatePublicChatbotSnippet,
        getQuestionsToReview,
        getSubjectAreas,
        acceptQuestion,
        rejectQuestion,
        deleteQuestion,
        rejectDeletionSuggestion,
        getFaqCmsSettings
      },
      dispatch
    ),
    dispatch
  };
}

FaqCms = connect(
  mapStateToProps,
  mapDispatchToProps
)(FaqCms);

export default withStyles(styles)(FaqCms);
